<template>
	<div style="margin-bottom: 15px">
		<div v-if="!isAdd">
			<el-card header="投保须知">
				<el-container ref="pdf" v-loading="isLoadingPdf" :style="setHeight">
					<el-main :style="!isCanScroll ? {overflow: 'hidden'} : {}" class="pdf-content">
						<el-alert :closable="false" style="margin-bottom: 10px" type="error">
							<span style="font-size: 1.25em; font-weight: bold">
								为保障您的合法权益，请您仔细阅读以下各部分内容，重要内容将以红色加粗字体为您标记，请务必知晓。如有疑问，请先联系客服人员确认无误后再行投保。
							</span>
						</el-alert>
						<div v-if="protocolInfoData.declareContent !== ''" class="center_info_content">
							<div v-if="currentPosition === -1" class="u-m-b-20" v-html="protocolInfoData.declareContent"></div>

							<div v-if="isShowPdf">
								<div v-if="currentPosition >= 0 && currentPdfPages > 0">
									<pdf
										v-for="index in visiblePages"
										:key="`${currentPosition}-${index}`"
										:page="index"
										:src="currentPdfSrc"
										style="margin-left: 200px; margin-right: 200px"
										@progress="onPdfProcess"
										@error="onPdfError"
										@page-loaded="onOverReload"></pdf>
								</div>
								<div v-if="currentPdfPages > 0 || currentPosition === -1" class="u-m-b-20">
									<div class="customPage">{{ currentPosition + 2 }}/{{ pdfPath.length + 1 }}</div>
									<div v-if="!isHideBtn" style="display: flex; justify-content: center">
										<el-button :disabled="currentPosition === -1" plain type="default" @click="onPageLast">
											上一页
										</el-button>
										<el-button :disabled="currentNum > 0" type="primary" @click="onPageNext">
											{{ currentNum > 0 ? `${currentNum}s后可关闭` : '我已逐条阅读并同意' }}
										</el-button>
									</div>
								</div>
							</div>
						</div>
					</el-main>
				</el-container>
			</el-card>

			<div v-if="!isShowPdf">
				<el-card v-if="protocolInfoData.clauseFileUrls || []" class="u-m-t-20" header="保险条款">
					<div v-for="(itemData, index) in protocolInfoData.clauseFileUrls" class="link" :key="index">
						<el-link :href="itemData.url" target="_blank" type="primary">
							{{ itemData.name.replace('.pdf', '') }}
						</el-link>
						<br />
					</div>
				</el-card>
				<el-card v-if="protocolInfoData.delegateFileUrls" class="u-m-t-20" header="保险经纪服务委托协议">
					<div v-for="(itemData, index) in protocolInfoData.delegateFileUrls" class="link" :key="index">
						<el-link :href="itemData.url" target="_blank" type="primary">
							{{ itemData.name.replace('.pdf', '') }}
						</el-link>
						<br />
					</div>
				</el-card>
				<el-card v-if="protocolInfoData.webServiceFileUrl" class="u-m-t-20" header="网站服务协议">
					<div v-for="(itemData, index) in protocolInfoData.webServiceFileUrl" class="link" :key="index">
						<el-link :href="itemData.url" target="_blank" type="primary">
							{{ itemData.name.replace('.pdf', '') }}
						</el-link>
						<br />
					</div>
				</el-card>
			</div>

			<el-card v-if="isHideBtn || !isShowPdf" class="u-m-t-20" header="投保人声明">
				<el-alert :closable="false" class="u-m-b-10" type="error">
					<span class="u-font-weight-bold u-font-14">为保障您的合法权益，请您仔细阅读后勾选确认</span>
				</el-alert>
				<el-row v-if="protocolInfoData.declares || []" justify="start" type="flex">
					<el-checkbox-group v-model="checkListStatement">
						<el-checkbox
							v-for="{content = ''} in protocolInfoData.declares"
							:key="content"
							:label="content"
							class="u-m-b-10"></el-checkbox>
					</el-checkbox-group>
				</el-row>
				<el-row justify="center" style="margin-top: 5px" type="flex">
					<el-tag type="">
						<span class="u-font-weight-bold u-font-14">请滑动鼠标至底部，阅读并确认全部内容</span>
					</el-tag>
					<p></p>
				</el-row>
				<el-row justify="center" type="flex">
					<el-button v-if="isShowPdf" plain type="primary" @click="onBackInsured">查看投保须知</el-button>
					<el-button :disabled="!onSureAble" type="primary" @click="onStepConfirm">我已逐条阅读并同意投保</el-button>
				</el-row>
			</el-card>
		</div>
		<div v-else class="u-flex u-row-center u-m-t-20">
			<el-button type="primary" @click="onStepConfirm">同意投保</el-button>
		</div>
	</div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件等等）
// import { mapGetters } from 'vuex'
import pdf from 'vue-pdf'
import {isMeiYa} from 'meibao-insure/src/util/productUtil'

export default {
	name: 'customNotice',
	mixins: [],
	components: {pdf},
	props: {
		protocolInfoData: {
			type: Object,
			required: true,
			default: () => {
				return {
					declareContent: '',
					declares: [],
					clauseFileUrls: [],
					delegateFileUrls: [],
					webServiceFileUrl: [],
				}
			},
		},
		productId: String | Number,
		sourceProductId: String | Number,
		insureType: String | Number,
		isAdd: Boolean,
		isCanScroll: Boolean,
	},
	data() {
		return {
			currentPosition: -1,
			isLoadingPdf: false,
			pdfPath: [],
			currentPdfPages: 0,
			currentPdfUrl: '',
			isHideBtn: false,
			clickable: null,
			currentNum: '我已逐条阅读并同意',
			checkListStatement: [],
			isShowPdf: false,
			// 分批加载相关
			visiblePages: 0, // 当前可见的页面数量
			batchSize: 3, // 每批加载的页面数量
			loadBatchTimer: null, // 分批加载定时器
		}
	},
	computed: {
		// ...mapGetters(['userPermissions','buttonType'])
		setHeight() {
			if (!this.isShowPdf) {
				return ''
			}
			return {height: '660px'}
		},
		//是否可点击
		onSureAble() {
			return (
				this.checkListStatement.length > 0 && this.checkListStatement.length >= this.protocolInfoData.declares.length
			)
		},
		// 当前PDF的URL（确保响应式更新）
		currentPdfSrc() {
			if (this.currentPosition >= 0 && this.pdfPath && this.pdfPath[this.currentPosition]) {
				return this.pdfPath[this.currentPosition].url
			}
			return ''
		},
	},
	watch: {
		protocolInfoData: {
			handler(newVal, oldVal) {
				if (!this.validatenull(newVal)) {
					let {clauseFileUrls = [], delegateFileUrls = [], webServiceFileUrl = []} = newVal
					//处理pDF
					if (this.pdfPath.length === 0) {
						this.pdfPath = clauseFileUrls.concat(delegateFileUrls).concat(webServiceFileUrl)
					}
				}
			},
			immediate: true,
		},
		// insureType: {
		//   handler(newVal, oldVal) {
		//     if (!this.validatenull(newVal)) {
		//       //监听获取数据，处理需要看到的数据
		//       this.onDealInsureType(newVal)
		//     }
		//   },
		//   immediate: true
		// }
	},
	created() {},
	mounted() {
		//判断是否需要PDF
		if (this.envConfig.isBxIe()) {
			this.isShowPdf = !isMeiYa(this.insureType)
		}
	},
	methods: {
		/**
		 * 上一页PDF文档
		 */
		onPageLast() {
			if (this.currentPosition > -1) {
				this.currentPosition--
			}
			// 如果当前位置有效，加载对应的PDF
			if (this.currentPosition !== -1) {
				console.log(`切换到上一页PDF，位置: ${this.currentPosition}`)
				this.loadingPdf()
			} else {
				// 回到声明页面，重置状态
				console.log('回到声明页面')
				this.resetBatchLoadingState()
				this.currentPdfPages = 0
			}
			this.$nextTick(() => {
				this.onScrollToPos()
			})
			this.currentNum = 4
			if (this.clickable) {
				clearInterval(this.clickable)
				this.clickable = null
			}
			this.setClickable()
		},
		/**
		 * 下一页PDF文档
		 */
		onPageNext() {
			if (this.currentPosition < this.pdfPath.length - 1) {
				this.currentPosition++
				console.log(`切换到下一页PDF，位置: ${this.currentPosition}`)
				this.loadingPdf()
				this.$nextTick(() => {
					this.onScrollToPos()
				})
			} else {
				//全部阅读完
				this.isHideBtn = true
				this.$emit('onInsureReadOver', false)
			}
			this.currentNum = 4
			this.setClickable()
		},
		//滑动
		onScrollToPos() {
			let main = document.getElementsByClassName('pdf-content')[0]
			if (main) {
				main.scrollTo({
					top: 0,
					behavior: 'smooth',
				})
			}
		},
		/**
		 * 加载PDF文档
		 */
		loadingPdf() {
			if (this.currentPosition >= 0 && this.pdfPath && this.pdfPath[this.currentPosition]) {
				const pdfUrl = this.pdfPath[this.currentPosition].url
				console.log(`开始加载PDF，位置: ${this.currentPosition}, URL: ${pdfUrl}`)
				this.isLoadingPdf = true
				// 强制清除之前的状态
				this.currentPdfPages = 0
				// 重置分批加载状态
				this.resetBatchLoadingState()
				setTimeout(() => {
					this.currentPdfUrl = pdf.createLoadingTask({
						url: pdfUrl,
						// 引入pdf.js字体，修复不显示
						cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.5.207/cmaps/',
						cMapPacked: true,
					})
					console.log('PDF加载任务已创建，等待Promise resolve...')

					this.currentPdfUrl.promise
						.then((pdfDoc) => {
							console.log(`PDF Promise resolved，总页数: ${pdfDoc.numPages}`)
							this.currentPdfPages = pdfDoc.numPages
							// 开始分批加载页面
							this.startBatchLoading()
							// 根据总页数设置基础加载时间
							this.isLoadingPdf = false
							console.log('PDF初始加载完成')
							// setTimeout(() => {
							// }, 200 * Math.min(this.batchSize, this.currentPdfPages))
						})
						.catch((error) => {
							console.error('PDF Promise rejected:', error)
							console.error('PDF路径信息:', {
								currentPosition: this.currentPosition,
								pdfPath: this.pdfPath,
								url: pdfUrl,
							})
							this.isLoadingPdf = false
							this.currentPdfPages = -1
							this.resetBatchLoadingState()
							this.$alert(`PDF加载失败：错误信息${error.$message}`, '提示').then(() => {})
						})
						.finally(() => {
							console.log('insureNoticesNew------->', 'finally')
							this.isLoadingPdf = false
						})
				}, 1000)
			} else {
				console.warn('无法加载PDF:', {
					currentPosition: this.currentPosition,
					pdfPath: this.pdfPath,
					pdfPathLength: (this.pdfPath && this.pdfPath.length) || 0,
				})
			}
		},

		/**
		 * 开始分批加载页面
		 */
		startBatchLoading() {
			// 先加载第一批页面（根据batchSize设置）
			this.visiblePages = Math.min(this.batchSize, this.currentPdfPages)
			console.log(`开始分批加载，首批显示 ${this.visiblePages} 页，总页数 ${this.currentPdfPages}`)
			// 如果总页数超过第一批，设置定时器继续加载
			if (this.currentPdfPages > this.batchSize) {
				this.loadBatchTimer = setTimeout(() => {
					this.loadNextBatch()
				}, 600) // 1秒后加载下一批
			}
		},

		/**
		 * 加载下一批页面
		 */
		loadNextBatch() {
			if (this.visiblePages < this.currentPdfPages) {
				// 增加可见页面数量
				const nextBatchSize = Math.min(this.batchSize, this.currentPdfPages - this.visiblePages)
				this.visiblePages += nextBatchSize
				console.log(
					`加载第${Math.ceil(this.visiblePages / this.batchSize)}批页面，当前显示: ${this.visiblePages}/${
						this.currentPdfPages
					}`,
				)
				// 如果还有更多页面，继续设置定时器
				if (this.visiblePages < this.currentPdfPages) {
					this.loadBatchTimer = setTimeout(() => {
						this.loadNextBatch()
					}, 600) // 每隔1秒加载下一批
				}
			}
		},

		/**
		 * 清理分批加载定时器
		 */
		clearBatchTimer() {
			if (this.loadBatchTimer) {
				clearTimeout(this.loadBatchTimer)
				this.loadBatchTimer = null
			}
		},

		/**
		 * 重置分批加载状态
		 */
		resetBatchLoadingState() {
			this.visiblePages = 0
			this.clearBatchTimer()
			console.log('重置分批加载状态')
		},
		onBackInsured() {
			//返回查看
			this.isHideBtn = false
			this.$emit('onInsureReadOver', this.isHideBtn)
			this.onScrollToPos()
		},
		//倒计时3秒后可点击
		setClickable() {
			if (this.clickable) {
				return
			}
			this.clickable = setInterval(() => {
				this.currentNum--
				if (this.currentNum <= 0) {
					clearInterval(this.clickable)
					this.clickable = null
				}
			}, 1000)
		},
		onPdfProcess(num) {},
		/**
		 * PDF页面加载完成回调
		 * @param {number} num - 页面编号
		 */
		onOverReload(num) {
			let tempCanvas = document.getElementsByTagName('canvas')
			this.$nextTick(() => {
				setTimeout(() => {
					if (tempCanvas.length > 0 && num <= tempCanvas.length) {
						tempCanvas[num - 1].setAttribute('state', 'rendered')
					}
				}, 500) // 减少延迟提升响应速度
			})
		},
		onStepConfirm() {
			//最后确认！！！
			this.$emit('onFirstStepConfirm')
		},
		//mock
		onSetNoticesMockData() {
			if (this.isShowPdf) {
				this.isHideBtn = true
				this.checkListStatement = [1, 2]
			}
		},

		/**
		 * 强制重新加载当前PDF（调试用）
		 */
		forceReloadPdf() {
			console.log('强制重新加载PDF')
			this.resetBatchLoadingState()
			this.currentPdfPages = 0
			this.$nextTick(() => {
				this.loadingPdf()
			})
		},
		onPdfError(error) {
			console.log('PDF加载失败:', error)
			this.$alert(`PDF-加载失败：错误信息${error.$message}`, '提示').then(() => {})
		},
	},
	activated() {},
	updated() {},
	beforeDestroy() {
		// 清理定时器
		this.clearBatchTimer()
		if (this.clickable) {
			clearInterval(this.clickable)
			this.clickable = null
		}

		// 取消PDF加载任务
		if (this.currentPdfUrl && this.currentPdfUrl.destroy) {
			try {
				this.currentPdfUrl.destroy()
				console.log('组件销毁：已取消PDF加载任务')
			} catch (e) {
				console.warn('组件销毁：取消PDF加载任务失败:', e)
			}
		}
	},
	destroyed() {},
	beforeRouteEnter(to, from, next) {
		next()
	},
	beforeRouteUpdate(to, from, next) {
		next()
	},
	beforeRouteLeave(to, from, next) {
		next()
	},
}
</script>

<style lang="scss" scoped>
.customPage {
	display: flex;
	justify-content: center;
	font-size: 26px;
	font-weight: bold;
}

.title_bold_custom {
	font-weight: bold;
}

.title_bold {
	font-size: 20px;
	font-weight: bold;
	margin: 15px 0 10px;
	text-align: center;
}

.insure_confirm {
	font-size: 15px;
	line-height: 28px;
	white-space: pre-line;
}

::v-deep .el-checkbox__label {
	display: inline-grid;
	width: 100%;
	white-space: pre-line;
	word-wrap: break-word;
}

.loading-more-pages {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px;
	color: #666;
	font-size: 14px;
	background-color: #f8f9fa;
	border-radius: 4px;
	margin: 10px 200px;

	.el-icon {
		margin-right: 8px;
		font-size: 16px;
	}
}

.debug-info {
	position: fixed;
	top: 10px;
	right: 10px;
	background: rgba(0, 0, 0, 0.8);
	color: white;
	padding: 10px;
	border-radius: 4px;
	font-size: 12px;
	z-index: 9999;
	max-width: 300px;

	p {
		margin: 2px 0;
		word-break: break-all;
	}
}
</style>
